import { ToolBarStandardButton, ToolBarStandardButtonType } from "../core/components/toolBar";
import { Grid } from "../core/components/grid";
import { Helper } from "../core/util/helper";
import { HTTPService, JsonResultClass } from "../core/util/httpManager";
import { General } from "../../siteManagement/general";
import { SheetEventType } from "../../siteManagement/sheet";
import PartsCS, { EntityPartsCS, PartsCSProps } from "./partsCS";
import { NotificationHelper } from "../core/util/notificationHelper";
import { AppHelper } from "../appHelper";
import { DialogHelper } from "../core/util/dialogHelper";
import { PartsAppProps } from "./parts";
import { Metadata } from "../core/components/commonApp";
import { KeyValuePair } from "../commonInterfaces";
import { StocksService } from "../stock/stocksService";
import React from "react";
export default class PartsCSGrid extends React.Component<PartsAppPropsCSApp, { data: EntityPartsCS[]; selected: EntityPartsCS}>{
    //private _gridData = [];
    private gridOptions = {};
    private dataUrl: string;
    private metaData: Metadata = null;
    private states: KeyValuePair<number, string>[] = [];
    private warehouses: any[] = [];
    common = new AppHelper();
    

    constructor(props: PartsAppPropsCSApp) {
        super(props)
        this.dataUrl = "Parts/GetChargenSerien?artNr=" + props.entity.ArtNr;
        this.gridOptions = props.context.CSGrid;
        this.state = {
            data: [],
            selected: null
        }
        this.initApp()
    }

    private initApp = async () => {
        const [metaData, states, warehouses] = await Promise.all([
            await Helper.getMetaData("partsCS"),
            StocksService.getTypes(8),
            await HTTPService.get("Warehouse/GetAllWarehouses")
        ]);
        this.warehouses = warehouses;
        this.states = states;
        this.metaData = metaData;
        this.setState({})
    }

    private async loadGridData() {
        const result = await HTTPService.get(this.dataUrl);
        this.setState({ data: result.Data });
    }

    private open = async (dataItem = null) => {
        let artNr = this.props.entity.ArtNr;
        let entity: EntityPartsCS;
        if (dataItem == null) {
            entity = {
                IsNew: true,
                RecordRight: this.props.entity.RecordRight,
                ArtNr: artNr,
                ChargenNr: null,
                SerienNr: null,
                Menge: null,
                Kommentar: null,
                IsWatchable: false,
                IsWatched: false,
                IndividualFields: {},
                Stocks: []
            }
        } else {
            const result = await HTTPService.get<JsonResultClass>(`Parts/GetCS?artNr=${dataItem.ArtNr}&chargenNr=${dataItem.ChargenNr}&serienNr=${dataItem.SerienNr}`);
            entity = result.Data;
        }
        entity.RecordRight = this.props.entity.RecordRight;
        const props: PartsCSProps = {
            dataSources: {
                states: this.states,
                warehouses: this.warehouses
            },
            metadata: this.metaData,
            entity: entity,
            isWindow: true,
            context: {
                contextType: "partsCS"
            },
            title: ""
        }
        const sheet = General.Sheet.Manager.createSheet();
        sheet.bind(SheetEventType.SavedSuccessfully, (target) => {
            this.loadGridData();
        });

        sheet.show(() => {
            sheet.mountContent(PartsCS, props);
        });
    }

    private delete = async (dataItem = null) => {
        const isOK = await DialogHelper.confirm(this.props.translations["Standard.Msg.Loeschen"]);
        if (isOK) {
            const result = await HTTPService.post<JsonResultClass>("Parts/DeleteCS", dataItem);
            if (result.Code === 0) {
                this.props.entity.IsNew = false;
                NotificationHelper.showSuccessMessage(result.Message);
                this.loadGridData();
            } else {
                NotificationHelper.showErrorMessage(result.Message);
            }
        }
        
    }

    private handleClickStandardButton = (type: ToolBarStandardButtonType, dataItem: EntityPartsCS) => {
        switch (type) {
            case ToolBarStandardButtonType.NEW:
                this.open();
                break;
            case ToolBarStandardButtonType.EDIT:
                this.open(dataItem);
                break;
            case ToolBarStandardButtonType.DELETE:
                this.delete(dataItem);
                break;
        }
    }

    componentDidMount() {
        this.loadGridData();
    }

    private onSelectionChange = (dataItem: EntityPartsCS) => {
        if (dataItem)
            this.setState({ selected: dataItem })
    }

    render() {
        const canBeDeleted = Helper.hasValue(this.state.selected) && !((this.state.selected.ChargenNr == "-") && (this.state.selected.SerienNr == "-"))
        const standardButtons: Array<ToolBarStandardButton> = [
            { type: ToolBarStandardButtonType.NEW, caption: Helper.getTranslation("Standard.Neu"), enabled: this.props.entity.RecordRight.CanWrite },
            { type: ToolBarStandardButtonType.EDIT, caption: Helper.getTranslation("Standard.Editieren"), enabled: this.props.entity.RecordRight.CanWrite  },
            { type: ToolBarStandardButtonType.DELETE, caption: Helper.getTranslation("Standard.Loeschen"), enabled: this.props.entity.RecordRight.CanWrite && canBeDeleted }
        ];
        return <Grid data={this.state.data} options={this.gridOptions} id="partsMatartcsItemsGrid" standardButtons={standardButtons} onClickStandardButton={this.handleClickStandardButton} onSelectionChanged={this.onSelectionChange} />
    }
}

interface PartsAppPropsCSApp extends PartsAppProps {
    translations: Array<string>;
}